import React from 'react';
import { Sparkles, BarChart3, Code, Telescope, Calendar, TrendingUp, Database, Zap } from 'lucide-react';
import '../../styles/website/AstrologerSection.css';

const AstrologerSection = () => {
  return (
    <section className="premium-section astrologer-section" id="astrologer">
      <div className="premium-container">
        <div className="premium-icon-wrapper">
          <div className="premium-icon">
            <Telescope size={64} />
          </div>
          <div className="icon-glow"></div>
        </div>
        
        <div className="premium-content">
          <span className="premium-badge">Premium Suite</span>
          <h2 className="premium-title">Astrologer Suite — Dashboard, Tools & API</h2>
          <p className="premium-tagline">Everything an astrologer needs — in one powerful panel.</p>
          
          <p className="premium-description">
            Astrologers and serious users get their own powerful dashboard with tools, charts, timelines, and APIs — everything needed for research, predictions, and professional work.
          </p>
          
          <div className="premium-features">
            <div className="feature-item">
              <BarChart3 size={20} />
              <span>Separate astrologer dashboard</span>
            </div>
            <div className="feature-item">
              <Sparkles size={20} />
              <span>Strength prediction tools</span>
            </div>
            <div className="feature-item">
              <Calendar size={20} />
              <span>Detailed timelines for every chart</span>
            </div>
            <div className="feature-item">
              <TrendingUp size={20} />
              <span>Transit movement in all formats</span>
            </div>
            <div className="feature-item">
              <Database size={20} />
              <span>Birth chart, divisional chart & transit API</span>
            </div>
            <div className="feature-item">
              <Code size={20} />
              <span>Prediction API for developers & apps</span>
            </div>
            <div className="feature-item">
              <Zap size={20} />
              <span>High-accuracy life cycle graphs</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AstrologerSection;
